import {Component, OnInit} from '@angular/core';
import {newPassForm} from '../../../Assets/angular/assets/data/forms/new_pass_form';
import {ClientService} from '../../services/client.service';

@Component({
    selector: 'app-new-password-form',
    templateUrl: './new-password-form.component.html',
    styleUrls: ['./new-password-form.component.scss']
})
export class NewPasswordFormComponent implements OnInit {

    newPassForm: Array<object>;
    modalCloseAction: string;

    constructor(public clientService: ClientService) {
        this.newPassForm = newPassForm;
        this.modalCloseAction = 'navigateToHome';
    }

    ngOnInit(): void {
    }

}
